export type UseViewportProps = {
  enabled: boolean;
  /**
   * Controls the size of the viewport. It can be set to a specific number of pixels like width=600 or to the special value device-width, which is 100vw, or 100% of the viewport width. Minimum: 1. Maximum: 10000. Negative values: ignored.
   */
  width?: string;
  /**
   * Controls the size of the viewport. It can be set to a specific number of pixels like height=400 or to the special value device-height, which is 100vh, or 100% of the viewport height. Minimum: 1. Maximum: 10000. Negative values: ignored.
   */
  height?: string;
  /**
   * Controls the zoom level when the page is first loaded. Minimum: 0.1. Maximum: 10. Default: 1. Negative values: ignored.
   */
  initialScale?: string;
  /**
   * Controls how much zoom out is allowed on the page. Minimum: 0.1. Maximum: 10. Default: 0.1. Negative values: ignored.
   */
  minimumScale?: string;
  /**
   * Controls how much zoom in is allowed on the page. Any value less than 3 fails accessibility. Minimum: 0.1. Maximum: 10. Default: 10. Negative values: ignored.
   */
  maximumScale?: string;
  /**
   * Controls whether zoom in and zoom out actions are allowed on the page. Valid values: 0, 1, yes, or no. Default: 1, which is the same as yes. Setting the value to 0, which is the same as no, is against Web Content Accessibility Guidelines (WCAG).
   */
  userScalable?: string;
  /**
   * 
   */
  shrinkToFit?: boolean;
  /**
   * 
   */
  viewportFit?: 'auto' | 'contain' | 'cover';
}

export function useViewport({ enabled, width, height, initialScale, minimumScale, maximumScale, userScalable, shrinkToFit, viewportFit }: UseViewportProps) {
  if (!enabled) {
    return <></>
  }

  const viewportContent: Array<string> = []
  
  if (width) {
    viewportContent.push(`width=${width}`)
  }
  if (height) {
    viewportContent.push(`height=${height}`)
  }
  if (initialScale) {
    viewportContent.push(`initial-scale=${initialScale}`)
  }
  if (minimumScale) {
    viewportContent.push(`minimum-scale=${minimumScale}`)
  }
  if (maximumScale) {
    viewportContent.push(`maximum-scale=${maximumScale}`)
  }
  if (userScalable) {
    viewportContent.push(`user-scalable=${userScalable}`)
  }
  if (shrinkToFit) {
    viewportContent.push(`shrink-to-fit=no`)
  }
  if (viewportFit) {
    viewportContent.push(`viewport-fit=${viewportFit}`)
  }

  return (
    <>
      <meta key='viewport' name='viewport' content={viewportContent.join(', ')} />
    </>
  )
}